import { HelpPageComponent } from './Components/TowLocate/help-page/help-page.component';
import { ResultsComponent } from './Components/TowLocate/results/results.component';

import { Routes } from '@angular/router';
import { HomePageComponent } from './Components/TowLocate/home-page/home-page.component';
import { MultipleResultsComponent } from './Components/TowLocate/multiple-results/multiple-results.component';

export const appRoutes: Routes = [

    {path:'HomePage',component:HomePageComponent},
    {path:'Results',component:ResultsComponent},
    {path:'Help',component:HelpPageComponent},
    {path:'MultiSelect',component:MultipleResultsComponent},
    {path:'',component:HomePageComponent},
    {path: '**', component: HomePageComponent},
    {path: 'https://findmycar.us',   redirectTo: 'https://fl.findmycar.us' }
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts